<template>
  <div>
    <mensajeSistema></mensajeSistema>
    <v-row>
      <v-col cols="3" class="mt-2 d-flex gap-10px">
        <v-select
          dense
          label="Nivel"
          :items="NivelesAdmin"
          item-value="id_nivel"
          @change="getAllGradosAdmin(id_nivel)"
          item-text="desc_nivel"
          v-model="id_nivel"
          style="max-width: 200px"
        ></v-select>
      </v-col>
      <v-col cols="3" class="mt-2 d-flex gap-10px">
        <v-select
          dense
          label="Grado"
          item-text="desc_grado"
          :items="listGrado"
          item-value="id"
          @change="getSeccionGrado(id_grado)"
          v-model="id_grado"
          style="max-width: 200px"
        ></v-select>
      </v-col>
       {{ horarioAsignacionDetalles }}
    </v-row>
<!-- Nueva fila para las secciones -->
<v-row v-for="(data, index) in seccionGrado" :key="index" class="justify-center align-center full-width">
  <v-col
    cols="12"
    md="12"
    class="d-flex flex-column justify-center align-center" 
  >
    <v-card-title class="text-center full-height">
      {{ data.nombre_seccion }} - {{ data.ck1_mant_turno.desc_turno }}
    </v-card-title>

    <ag-grid-vue
      class="ag-theme-custom"
      :style="{ width: '100%', height: '40vh' }"
      :columnDefs="columnDefs"
      :localeText="localeTextSpanish"
      :rowData="getRowDataForTurno(data.id_turno, data.id, observacionesHorarios)"
      @grid-ready="onGridReady"
      :gridOptions="gridOptionsSecondTable[index]"
    />
  </v-col>

</v-row>

<v-row justify="end" class="pr-10" v-if="rowData">
  <v-col cols="auto" md="6">
    <ButtonComp @click="deleteConfirm()" normalButton textButton="Eliminar" classColor="red" />
  </v-col>
</v-row>


  </div>
</template>

<script>
import ButtonComp from "../../../components/ComponentsEst/TableButtonComp.vue";
import axios from "../../../helpers/axios";
import { AgGridVue } from "ag-grid-vue";

// eslint-disable-next-line no-unused-vars
import { mapMutations, mapState, mapActions } from "vuex";

export default {
  name: "horariopornivel",
  components: { AgGridVue, ButtonComp },
  data: () => ({
    localeTextSpanish: {
      noRowsToShow:
        "Este nivel no tiene horario académico, por favor registrar en administración del colegio.",
    },
    id_colegio: sessionStorage.id_colegio,
    id_ano_lectivo: sessionStorage.id_ano_lectivo,
    NivelesAdmin: [],
    id_nivel: "",
    id_nivel_adm: "",
    listNivel: [],
    listGrado: [],
    id_grado: "",
    diasHabiles: [],
    diasSemanas: [],
    seccionGrado: [],
    nombresDiasHabiles: [],
    columnDefs: [],
    rowData: null,
    //datos para el calculo de las horas
    horariosAcademicos: [],
    horasDisponibles: [],
    duracionMinutos: "",
    primeraHora: "",
    horaEntrada: "",
    horaSalida: "",
    horaInicioRecreo: "",
    duracionRecreo: "",
    horaInicioRecreo2: "",
    nombre_recreo: "",
    nombre_recreo2: "",
    horasTotalDisponible: [],
    todosLosHorarios: [],
    gridOptionsSecondTable: [],
    arraySeccion: [],
    cursosSecciones: [],
    mensajeHorario: "",
    resetFields: false,
    dataChecked: false,
    observacionesHorarios: [],
  }),
  computed: {
    horarioAsignacionDetalles() {
      return this.$store.state.horarioAsignacionDetalles;
    }
  },

  watch: {
    horarioAsignacionDetalles(newVal, oldVal) {
      console.log('Valor antiguo:', oldVal);
      console.log('Nuevo valor:', newVal);
      if (newVal.length > 0) {
        console.log('Los datos ya están disponibles:', newVal);
      } else {
        console.log('Los datos aún no han llegado');
      }
    }
  },

  mounted() {
    this.$on("reset-fields", this.resetModel);
    this.getAllNivelesAdmin();
    this.GetNivel();
    this.cargarDatosYObtenerDiasHabiles();
  },

  methods: {
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    resetModel() {
      // Método para resetear los campos
      this.id_nivel = "";
      this.id_grado = "";
      this.listGrado = [];
      this.seccionGrado = [];
      this.columnDefs = [];
      this.rowData = null;
      this.todosLosHorarios = [];
    },

  
    async getAllNivelesAdmin() {
      let params = {
        id_colegio: this.id_colegio,
        id_ano_lectivo: this.id_ano_lectivo,
      };

      try {
        let response = await axios.post(
          "/administrativo/asignacionDocenteCurso/getNivel/",
          params
        );
        this.NivelesAdmin = response.data;
        this.id_nivel_adm = response.data[0].id_nivel_adm;
        
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje:
            error.response.data.message || "Error en la respuesta del servidor",
          tiempo: null,
        });
      }
    },

    async GetNivel() {
      let params = {
        id_colegio: this.id_colegio,
        id_ano_lectivo: this.id_ano_lectivo,
      };
      try {
        let response = await axios.post(`/sistema/integral/getNivelAdm/`, {
          filter: params,
        });

        this.listNivel = response.data;
        this.listNivel.sort((a, b) => a.desc_nivel.localeCompare(b.desc_nivel));
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getAllGradosAdmin(id_nivel) {
      let params = {
        id_colegio: this.id_colegio,
        id_ano_lectivo: this.id_ano_lectivo,
        id_nivel,
      };

      try {
        let response = await axios.post(
          "/administrativo/grado/gradosNivelAdmin/",
          params
        );
        this.listGrado = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getSeccionGrado(id_grado) {
      let params = {
        id_colegio: this.id_colegio,
        id_ano_lectivo: this.id_ano_lectivo,
        id_grado,
      };

      try {
        let response = await axios.post(
          "/administrativo/seccion/seccionGrado/",
          params
        );
        this.seccionGrado = response.data;
        this.seccionGrado.forEach((item) => {
          this.arraySeccion.push(item.id);
        });

        this.id_nivel_adm = this.seccionGrado[0].id_nivel;
        this.todosLosHorarios = [];
        this.rowData = [];
        await this.getCursosHorario();
        await this.getHorarioAcademico();
        await this.getHorarioObservaciones() 
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getHorarioObservaciones() {
  let params = {
    id_colegio: this.id_colegio,
    id_ano_lectivo: this.id_ano_lectivo,
    id_nivel: this.id_nivel_adm,
    arraySeccion: this.arraySeccion // Asegúrate de que coincida con el backend
  };

  try {
    let response = await axios.get("horario/horarioPorSeccion", { params });
    this.observacionesHorarios = response.data;
    console.log("Observaciones", this.observacionesHorarios);
  } catch (error) {
    this.observacionesHorarios = [];
  }
},

    async getCursosHorario() {
      let params = {
        id_colegio: this.id_colegio,
        id_ano_lectivo: this.id_ano_lectivo,
        id_nivel: this.id_nivel_adm,
        arraySeccion: this.arraySeccion,
      };

      try {
        let response = await axios.post("/horario/horarioPorSeccion/", params);
        this.cursosSecciones = response.data.data;

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getDiasDeLaSemana() {
      try {
        let response = await axios.get("/mantenimiento/diasSemanas");
        this.diasSemanas = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    async getDiasHabiles() {
      let id_colegio = this.id_colegio;

      try {
        let response = await axios.get(
          `/administrativo/calendarioAcademico/${id_colegio}`
        );
        this.diasHabiles = response.data[0].dias_seleccionados;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    async cargarDatosYObtenerDiasHabiles() {
      try {
        await Promise.allSettled([
          this.getDiasHabiles(),
          this.getDiasDeLaSemana(),
        ]);
        this.obtenerNombresDiasHabiles();
        this.actualizarColumnas();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    obtenerNombresDiasHabiles() {
      if (!this.diasSemanas) {
        return [];
      }

      this.nombresDiasHabiles = this.diasSemanas
        .filter((diaSemana) => this.diasHabiles.includes(diaSemana.id))
        .map((diaHabil) => ({
          id: diaHabil.id,
          nombre_dia: diaHabil.nombre_dia,
        }));
      return this.nombresDiasHabiles;
    },

    onGridReady(params) {
      params.api.sizeColumnsToFit();
    },

    actualizarColumnas() {
      if (!Array.isArray(this.nombresDiasHabiles)) {
        return;
      }
      
      // Inicializamos el arreglo de columnas dinámicas
      const columnasDinamicas = [
        {
          field: "hora",
          headerName: "Hora",
          pinned: "left", 
          width: 100, 
          headerClass: "ag-header-center", 
          cellClass: "ag-cell-center",
        },
      ];

      // Añadimos las columnas para los días hábiles
      this.nombresDiasHabiles.forEach((dia) => {
        columnasDinamicas.push({
          headerName: dia.nombre_dia,
          field: dia.nombre_dia.toLowerCase(),
          width:150,
          lockPosition: true,
          suppressMenu: true,
          sortable: false,
         // cellClass: "ag-cell-center",
        });
      });

      // Agregamos la nueva columna de observaciones
      columnasDinamicas.push({
        headerName: "Observaciones",  // Nombre de la columna
        field: "observaciones",       // Nombre del campo que se usará para los datos
        width: 300,                   // Ancho de la columna
        flex: 1,
        editable: true,               // Permite la edición directa en la celda
        sortable: false,              // No es necesario ordenar esta columna
        suppressMenu: true,           // Ocultar el menú de la columna
      });

      // Actualizamos las definiciones de columnas en la tabla
      this.columnDefs = columnasDinamicas;

      // Si el gridApi está disponible, actualizamos las columnas en el grid
      if (this.gridApi) {
        this.gridApi.setColumnDefs(this.columnDefs);
      }
    },

    async getHorarioAcademico() {
      try {
        let response = await axios.get(
          `/administrativo/horarioAcademico/${this.id_colegio}/${this.id_nivel_adm}/`
        );
        this.horariosAcademicos = response.data.data;

        this.horariosAcademicos.forEach((horario, index) => {
          this.calcularHora(index);
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    calcularHora(index) {
      this.asignarVariablesHorario(index);
      let horario = this.horariosAcademicos[index];
      let horasDisponibles = [];

      let horaInicio = horario.hora_entrada.split(":").slice(0, 2).join(":");
      let horaFin = horario.hora_salida.split(":").slice(0, 2).join(":");
      let horaInicioRecreo = horario.inicio_recreo1
        .split(":")
        .slice(0, 2)
        .join(":");
      let horaInicioRecreo2 = horario.inicio_recreo2
        .split(":")
        .slice(0, 2)
        .join(":");

      let primeraHora = parseInt(horario.hora_de_formacion.split(":")[1]);
      // eslint-disable-next-line no-unused-vars
      let duracionMinutos = parseInt(horario.duracion_hora_academica);

      // Tratamiento de la primera hora de formación
      if (primeraHora !== null && !isNaN(primeraHora)) {
        const horasPrimera = Math.floor(primeraHora / 60);
        const minutosPrimera = primeraHora % 60;
        let nuevaHoraInicio = new Date(
          2022,
          0,
          1,
          parseInt(horaInicio.split(":")[0]) + horasPrimera,
          parseInt(horaInicio.split(":")[1]) + minutosPrimera
        );
        let horaFinFormacion = `${nuevaHoraInicio
          .getHours()
          .toString()
          .padStart(2, "0")}:${nuevaHoraInicio
          .getMinutes()
          .toString()
          .padStart(2, "0")}`;

        if (horaInicio !== horaFinFormacion) {
          horasDisponibles.push({
            hora: `${horaInicio} - ${horaFinFormacion}`,
            tipo: "Formación",
            horaInicio,
            horaFin: horaFinFormacion,
            id_turno: horario.id_turno,
          });
          horaInicio = horaFinFormacion;
        }
      }

      // Extraer horas, minutos y segundos de la duración
      let [horasDuracion, minutosDuracion, segundosDuracion] =
        this.duracionMinutos.split(":").map(Number);

      // Calcular la duración total en minutos
      let duracionTotalMinutos =
        horasDuracion * 60 + minutosDuracion + segundosDuracion / 60;

      while (horaInicio < horaFin) {
        let [hora, minuto] = horaInicio.split(":").map(Number);
        let inicio = new Date(2022, 0, 1, hora, minuto);

        // Manejo de los recreos
        if (horaInicio === horaInicioRecreo) {
          // Convertir el tiempo de recreo de formato "00:20:00" a minutos
          let [horas, minutos, segundos] = horario.tiempo_de_recreo
            .split(":")
            .map(Number);
          let tiempoRecreoEnMinutos = horas * 60 + minutos + segundos / 60;

          // Crear un objeto Date para la hora de inicio del recreo
          let inicioRecreo = new Date(
            2022,
            0,
            1,
            parseInt(horaInicio.split(":")[0]),
            parseInt(horaInicio.split(":")[1])
          );

          // Sumar el tiempo de recreo
          let finRecreo = new Date(
            inicioRecreo.getTime() + tiempoRecreoEnMinutos * 60000
          );

          let horaFinRecreo = `${finRecreo
            .getHours()
            .toString()
            .padStart(2, "0")}:${finRecreo
            .getMinutes()
            .toString()
            .padStart(2, "0")}`;

          horasDisponibles.push({
            hora: `${horaInicio} - ${horaFinRecreo}`,
            tipo: this.nombre_recreo,
            horaInicio,
            horaFin: horaFinRecreo,
            id_turno: horario.id_turno,
          });

          // Actualizar horaInicio para la siguiente iteración
          horaInicio = horaFinRecreo;
          inicio = finRecreo;
        }

        if (horaInicio === horaInicioRecreo2) {
          // Convertir el tiempo de recreo2 de formato "00:20:00" a minutos
          let [horas, minutos, segundos] = horario.tiempo_de_recreo2
            .split(":")
            .map(Number);
          let tiempoRecreo2EnMinutos = horas * 60 + minutos + segundos / 60;

          // Crear un objeto Date para la hora de inicio del recreo2
          let inicioRecreo2 = new Date(
            2022,
            0,
            1,
            parseInt(horaInicio.split(":")[0]),
            parseInt(horaInicio.split(":")[1])
          );

          // Sumar el tiempo de recreo2
          let finRecreo2 = new Date(
            inicioRecreo2.getTime() + tiempoRecreo2EnMinutos * 60000
          );

          let horaFinRecreo2 = `${finRecreo2
            .getHours()
            .toString()
            .padStart(2, "0")}:${finRecreo2
            .getMinutes()
            .toString()
            .padStart(2, "0")}`;

          horasDisponibles.push({
            hora: `${horaInicio} - ${horaFinRecreo2}`,
            tipo: this.nombre_recreo2,
            horaInicio,
            horaFin: horaFinRecreo2,
            id_turno: horario.id_turno,
          });

          horaInicio = horaFinRecreo2;
          inicio = finRecreo2;
        }

        let fin = new Date(inicio.getTime() + duracionTotalMinutos * 60000);
        let horasFin = fin.getHours().toString().padStart(2, "0");
        let minutosFin = fin.getMinutes().toString().padStart(2, "0");
        let nuevoInicio = `${horasFin}:${minutosFin}`;

        if (nuevoInicio > horaFin) break;

        horasDisponibles.push({
          hora: `${horaInicio} - ${nuevoInicio}`,
          tipo: "Clase",
          horaInicio,
          horaFin: nuevoInicio,
          id_turno: horario.id_turno,
        });
        horaInicio = nuevoInicio;
      }
      this.todosLosHorarios = this.todosLosHorarios.concat(horasDisponibles);

    },

    asignarVariablesHorario(index) {
      if (index >= this.horariosAcademicos.length) {
        return;
      }

      const horario = this.horariosAcademicos[index];
      // Asignar variables de instancia basadas en el horario específico
      this.duracionMinutos = horario.duracion_hora_academica;
      this.primeraHora = parseInt(horario.hora_de_formacion.split(":")[1]);
      this.horaEntrada = horario.hora_entrada;
      this.horaSalida = horario.hora_salida;
      this.horaInicioRecreo = horario.inicio_recreo1;
      this.duracionRecreo = parseInt(horario.tiempo_de_recreo.split(":")[1]);
      this.horaInicioRecreo2 = horario.inicio_recreo2;
      this.duracionRecreo2 = parseInt(horario.tiempo_de_recreo2.split(":")[1]);
      this.nombre_recreo = horario.titulo_recreo1;
      this.nombre_recreo2 = horario.titulo_recreo2;
    },

    getRowDataForTurno(id_turno, id_seccion, observacionesHorarios) {
  // Filtrar todosLosHorarios para obtener solo los que coinciden con el id_turno
  let horariosFiltrados = this.todosLosHorarios.filter(
    (horario) => horario.id_turno === id_turno
  );

  // Buscar todas las observaciones correspondientes a la sección actual
  let observacionesDeSeccion = observacionesHorarios.filter(
    (observacion) => observacion.id_seccion === id_seccion
  );

  // Inicializamos el índice de observaciones para la sección actual
  let observacionIndex = 0;

  // Mapeo de horarios filtrados
  let rowData = horariosFiltrados.map((horario) => {
    // Buscar si existe un curso en cursosSecciones que coincida con la hora y el id_seccion
    let cursoData = this.cursosSecciones.find(
      (curso) =>
        curso.id_seccion === id_seccion && curso.hora === horario.hora
    );
  
    // Verificar si hay suficientes observaciones y coinciden con la hora actual del horario
    let observacion = null;
    if (
      observacionesDeSeccion.length > observacionIndex &&
      cursoData // Solo asignar observación si existe una coincidencia con cursoData
    ) {
      // Si hay coincidencia en horas y curso, asignar la observación
      observacion = observacionesDeSeccion[observacionIndex].observaciones;
      observacionIndex++;
    }

    if (cursoData) {
      // Si hay coincidencia en hora y id_seccion, combinar los datos con los del horario
      return {
        hora: horario.hora,
        lunes: cursoData.lunes || horario.lunes,
        martes: cursoData.martes || horario.martes,
        miércoles: cursoData.miercoles || horario.miercoles,
        jueves: cursoData.jueves || horario.jueves,
        viernes: cursoData.viernes || horario.viernes,
        sábado: cursoData.sabado || horario.sabado,
        domingo: cursoData.domingo || horario.domingo,
        observaciones: observacion ? observacion.join(', ') : ''
      };
    } else {
      // Si no hay coincidencia en cursos, devolver solo el horario sin observación
      return {
        ...horario,
        observaciones: '' // No asignar observación si no hay coincidencia
      };
    }
  });
  return rowData;
},



async deleteConfirm() {
  let params = {
    id_colegio: this.id_colegio,
    id_ano_lectivo: this.id_ano_lectivo,
    arraySeccion: this.arraySeccion,  // Asegúrate de que es un array
  };

  try {
    let response = await axios.post("horario/horarioPorSeccion/delete", params);  // Aquí los params van en el cuerpo

    if (response.status === 200) {
      await this.getCursosHorario();
     // await this.getHorarioObservaciones();
    }
  
    this.getCursosHorario
  } catch (error) {
    this.setEnviarMens({ tipo: "E", mensaje: `${error.response ? error.response.data : error.message}`, tiempo: null });
  }
}



  },
};
</script>
<style scope>
 
 .ag-cell-center {
    display: flex;
    justify-content: center; 
    align-items: center;    
    text-align: center;      
}
  .full-height {
  height: 100%; 
  display: flex;
  justify-content: center;
  align-items: center; 
}
 .ag-theme-custom {
  --ag-foreground-color: #000000; 
  --ag-border-color: rgb(197, 222, 246); 
  --ag-header-background-color: white; 
  --ag-header-foreground-color: #000000;
  --ag-header-border-color: rgb(1, 1, 21); 
}
.ag-theme-custom .ag-row:nth-child(odd) {
  background-color: white; 
}

.ag-theme-custom .ag-row:nth-child(even) {
  background-color: #ebf5f9; 
}

.ag-theme-custom .ag-cell:nth-child(odd) {
  background-color: rgba(235, 245, 249, 0.6);
}

.ag-theme-custom .ag-cell:nth-child(even) {
  background-color: rgba(255, 255, 255, 0.6);
}

.ag-theme-custom .ag-header-cell:nth-child(odd) {
  background-color: #ebf5f9; 
}

.ag-theme-custom .ag-header-cell:nth-child(even) {
  background-color: white; 
}

.ag-theme-custom .ag-header-cell[col-id="hora"] {
  background-color: #d9edf7; 
}

.ag-theme-custom .ag-cell[col-id="hora"] {
  background-color: #d9edf7; 
}
.align-center {
  align-items: center !important; 
}

.text-center {
  text-align: center !important; 
}
.ag-header-center {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>
